import { MainContext } from "contexts/MainContext";
import { useContext, useEffect, useState } from "react";
import LoadSvg from "utils/LoadSvg-v3";
import { AppParamsContext } from "contexts/AppParamsContext";

function Modal(props) {
  const {
    openCallback,
    closeCallback,
    onClickLayout,
    className,
    closeIcon,
    parentRef,
  } = props;

  const { popModal } = useContext(MainContext);
  const [isClosing, setIsClosing] = useState(false);

  const { appParams } = useContext(AppParamsContext);
  // const { x, y, reference, floating, strategy, update, refs } = useFloating({
  //   // placement: "bottom-start",
  //   middleware: [flip()],
  // });

  // useEffect(() => {
  //   reference(parentRef?.current);
  //   //eslint-disable-next-line
  // }, [parentRef]);

  // useEffect(() => {
  //   if (!refs.reference.current || !refs.floating.current) {
  //     return () => {};
  //   }
  //   return autoUpdate(
  //     refs.reference.current,
  //     refs.floating.current,
  //     update
  //   );
  //   //eslint-disable-next-line
  // }, [refs.reference, refs.floating, update]);

  useEffect(() => {
    if (typeof openCallback === "function") openCallback();
    return () => {
      if (typeof closeCallback === "function") {
        setIsClosing(true); // Trigger slide-down animation
        setTimeout(() => {
          closeCallback(); // Call closeCallback after animation duration
        }, 300); // Animation duration (in milliseconds)
      }
    };
    // eslint-disable-next-line
  }, []);

  const handleClickLayout = () => {
    if (typeof onClickLayout === "function") onClickLayout();
  };

  return (
    <div
      className={`modal modal-appear-effect ${
        appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
      } ${className != null ? className : ""}
      ${isClosing ? "slide-down" : ""}
      `}
    >
      <div
        className="modal-bgLayout"
        onClick={handleClickLayout}
        style={parentRef != null ? { background: "none" } : {}}
      ></div>
      <div
        className="modal-content"
        /*ref={floating}
        style={
          parentRef != null
            ? {
                position: strategy,
                boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#fff",
                top: y ?? "",
                left: x ?? "",
                width: "unset",
                borderRadius: "8px",
                padding: "4px",
              }
            : {}
        }*/
      >
        {closeIcon && (
          <div className="close-icon" onClick={popModal}>
            <LoadSvg name="setClose" />
          </div>
        )}
        {props.children}
      </div>
    </div>
  );
}

export default Modal;
